var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseDialog',{attrs:{"dialog":_vm.dialog},on:{"submit":_vm.submitForm}},[_c('BasketGiftCardForm',{ref:"form",attrs:{"without-email":true},on:{"validChanged":function($event){_vm.valid = $event}},model:{value:(_vm.fields),callback:function ($$v) {_vm.fields=$$v},expression:"fields"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }